import moment from "moment";
import { useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import SpinnerComponent from "../../../../Components/Loding/Spinner";
import StickyToolbar from "../../../../Components/StickyToolbar";
import ExportExcel from "../../../../Components/StickyToolbar/ExportExcel";
import Table from "../../../../Components/Table";
import {
    CarregarDistribuicaoController,
    ExportarExcelFilaAtendimentosCobrancaController,
    GetCasoCobrancaFilaAtendimentoPorGrupoController,
    ListarCasoCobrancaFilaAtendimentoDetalhadoPorGrupoController,
    ListarCasoCobrancaFilaAtendimentoPorGrupoController,
} from "../../../../Controllers/Cobranca/FilaAtendimento/FilaAtendimentoController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    ICasoCobrancaFilaAtendimentoPorGrupoProcedure,
    IFilaAtendimento,
} from "../../../../Interfaces/Cobranca/FilaAtendimento/FilaAtendimentoInterface";
import { formatMoneyReais } from "../../../../Tools/FormatTools";

export default function FilaAtendimentos() {
    const [LstGruposFila, setLstGruposFila] =
        useState<Array<IFilaAtendimento>>();
    const [loading] = useState(false);
    const [filtroAtivo, setFiltroAtivo] = useState(false);
    const [idGrupoCampanha, setIdGrupoCampanha] = useState<string[]>();

    useEffect(() => {
        CarregarDistribuicaoController().then(async (res) => {
            setIdGrupoCampanha(res[0]?.ID_CHAVE_GRUPO_CAMPANHA.split("_"));
            setLstGruposFila(res);
        });
    }, []);

    const {
        value: lstResultContatosDaFila,
        loading: lstResultContatosDaFilaLoading,
    } = useAsyncEffect(async () => {
        if (idGrupoCampanha) {
            return ListarCasoCobrancaFilaAtendimentoPorGrupoController(
                Number.parseInt(idGrupoCampanha[0]),
                Number.parseInt(idGrupoCampanha[1])
            );
        }
    }, [idGrupoCampanha]);

    const { value: ContatosDaFila, loading: contatosDaFilaLoading } =
        useAsyncEffect(async () => {
            if (idGrupoCampanha) {
                return ListarCasoCobrancaFilaAtendimentoDetalhadoPorGrupoController(
                    Number.parseInt(idGrupoCampanha[0]),
                    Number.parseInt(idGrupoCampanha[1])
                );
            }
        }, [idGrupoCampanha]);

    const { value: GrupoFila, loading: grupoFilaLoading } =
        useAsyncEffect(async () => {
            if (idGrupoCampanha) {
                return GetCasoCobrancaFilaAtendimentoPorGrupoController(
                    Number.parseInt(idGrupoCampanha[0]),
                    Number.parseInt(idGrupoCampanha[1])
                );
            }
        }, [idGrupoCampanha]);

    const Filter: JSX.Element = (
        <div className="col-12 mt-3">
            <label>Fila Atendimento</label>
            <select
                className="form-control"
                onChange={(e) => {
                    if (!!e.target.value) {
                        const idGrupoCampanha = e.target.value.split("_");
                        setIdGrupoCampanha(idGrupoCampanha);
                    }
                    setFiltroAtivo(!!e.target.value);
                }}
            >
                <option value={""}>Selecione uma fila</option>
                {LstGruposFila?.map((grupo) => (
                    <option
                        value={grupo.ID_CHAVE_GRUPO_CAMPANHA}
                        key={grupo.ID_GRUPO}
                    >
                        {grupo.DS_GRUPO}
                    </option>
                ))}
            </select>
        </div>
    );

    //tabela
    const controlSizePerPage = [2];
    if (lstResultContatosDaFila && lstResultContatosDaFila.length > 2)
        controlSizePerPage.push(
            lstResultContatosDaFila.length > 10
                ? 10
                : lstResultContatosDaFila.length
        );

    const rowTable = (
        cell: any,
        row: ICasoCobrancaFilaAtendimentoPorGrupoProcedure
    ) => {
        const fila = row;
        return (
            <div
                className="card card-custom w-auto ml-auto wave wave-animate-slow wave-warning border-bottom border-1 border-dark"
                key={
                    row.ID_CASO_COBRANCA_FATO +
                    row.ID_CASO_COBRANCA_FILA_ATENDIMENTO
                }
            >
                <div className="card-body p-3">
                    <div className="d-flex align-itens-center justify-content-between mb-1">
                        <h3 className="font-weight-bolder font-size-normal">
                            <span className="text-dark-75">
                                {fila.DS_CLIENTE}
                            </span>
                        </h3>
                    </div>
                    <div className="d-flex flex-wrap align-itens-center justify-content-between mb-1">
                        {fila.DT_ENTRADA_FILA && (
                            <div className="d-flex flex-wrap flex-column mr-1">
                                <span className="d-block font-weight-bold">
                                    Data entrada fila
                                </span>
                                <span className="label label-light-primary label-inline mr-2 my-1">
                                    {moment(fila.DT_ENTRADA_FILA).format("ll")}
                                </span>
                            </div>
                        )}
                        {fila.DT_RETORNO_FILA && (
                            <div className="d-flex flex-wrap flex-column">
                                <span className="d-block font-weight-bold">
                                    Data retorno fila
                                </span>
                                <span className="label label-light-primary label-inline mr-2 my-1">
                                    {moment(fila.DT_RETORNO_FILA).format("ll")}
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="d-flex flex-wrap justify-content-between mr-1">
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Valor Juros Atraso
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(fila.VL_JUROS_ATRASO)}
                            </span>
                        </div>
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Valor Parcelas em Aberto
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(fila.VL_PARCELAS_EM_ABERTO)}
                            </span>
                        </div>
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Multa
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(fila.VL_MULTA_ATRASO)}
                            </span>
                        </div>
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Juros
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(fila.VL_JUROS_ATRASO)}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_CLIENTE",
            text: "Total de Contratos da Fila",
            formatter: rowTable,
            headerClasses: "font-size-h3 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
    ];
    const tableViewColumns: Array<
        ColumnDescription<ICasoCobrancaFilaAtendimentoPorGrupoProcedure>
    > = [
        {
            dataField: "ID_CHAVE_ERP",
            text: "Chave",
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DS_CLIENTE",
            text: "Cliente",
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DS_IDENTIFICADOR",
            text: "Unidade",
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "NR_ORDEM",
            text: "Ordem",
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DS_CLASSIFICACAO_CONTRATO",
            text: "Classificação",
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DS_OBSERVACAO",
            text: "Observação",
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DT_RETORNO_FILA",
            text: "Data Retorno Fila",
            formatter: (c) => c && new Date(c).toLocaleDateString(),
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
    ];

    return (
        <>
            {!lstResultContatosDaFilaLoading &&
            !grupoFilaLoading &&
            !contatosDaFilaLoading ? (
                ContatosDaFila ? (
                    <>
                        <div className="d-flex flex-wrap flex-row card card-custom w-auto gutter-b m-5 justify-content-center">
                            <span className="h5 text-dark text-hover-success p-4">
                                {GrupoFila?.DS_GRUPO}
                            </span>

                            <div className="d-flex flex-wrap flex-row card card-custom p-2 justify-content-between">
                                <div className="card card-custom wave wave-animate wave-primary col-12 col-md-3 p-2 justify-content-center">
                                    <div className="d-flex align-items-center justify-content-between p-2 flex-lg-wrap flex-xl-nowrap">
                                        <div
                                            className="d-flex flex-column "
                                            style={{ zIndex: 1 }}
                                        >
                                            <span className="h5 text-dark text-hover-success">
                                                TOTAL DE CONTRATOS DA FILA
                                                ATENDIMENTO-
                                                {ContatosDaFila.LstNaoPodeCobrar
                                                    .length +
                                                    ContatosDaFila.LstAdimplente
                                                        .length +
                                                    ContatosDaFila
                                                        .LstFilaEmAtendimento
                                                        .length +
                                                    ContatosDaFila
                                                        .LstContatoEfetivo
                                                        .length +
                                                    ContatosDaFila
                                                        .LstContatoNaoEfetivo
                                                        .length +
                                                    ContatosDaFila
                                                        .LstTentativaContato
                                                        .length +
                                                    ContatosDaFila
                                                        .LstFilaAtender.length}
                                            </span>
                                            <p className="text-dark-50 m-0 p-0">
                                                {formatMoneyReais(
                                                    ContatosDaFila.VL_N_PODE_COBRAR +
                                                        ContatosDaFila.VL_ADIMPLENTE +
                                                        ContatosDaFila.VL_FILAATENDIMENTO +
                                                        ContatosDaFila.VL_CONTATOEFETIVO +
                                                        ContatosDaFila.VL_CONTATONAOEFETIVO +
                                                        ContatosDaFila.VL_FILAATENDER +
                                                        ContatosDaFila.VL_FILAATENDIMENTO +
                                                        ContatosDaFila.VL_TENTATIVACONTATO
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-wrap flex-row col-12 col-md-2">
                                    <div className="card card-custom gutter-b bg-light-primary col-12 m-1 justify-content-center">
                                        <div className="d-flex align-items-center justify-content-between p-2 flex-lg-wrap flex-xl-nowrap">
                                            <div
                                                className="d-flex flex-column "
                                                style={{ zIndex: 1 }}
                                            >
                                                <span className="h5 text-dark text-hover-success">
                                                    Não Pode Cobrar-
                                                    {
                                                        ContatosDaFila
                                                            .LstNaoPodeCobrar
                                                            .length
                                                    }
                                                </span>
                                                <p className="text-dark-50 m-0 p-0">
                                                    {formatMoneyReais(
                                                        ContatosDaFila.VL_N_PODE_COBRAR
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card card-custom gutter-b bg-light-primary col-12 m-1 justify-content-center">
                                        <div className="d-flex align-items-center justify-content-between p-2 flex-lg-wrap flex-xl-nowrap">
                                            <div
                                                className="d-flex flex-column "
                                                style={{ zIndex: 1 }}
                                            >
                                                <span className="h5 text-dark text-hover-success">
                                                    Adimplentes-
                                                    {
                                                        ContatosDaFila
                                                            .LstAdimplente
                                                            .length
                                                    }
                                                </span>
                                                <p className="text-dark-50 m-0 p-0">
                                                    {formatMoneyReais(
                                                        ContatosDaFila.VL_ADIMPLENTE
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-wrap flex-row col-12 col-md-2">
                                    <div className="card card-custom gutter-b bg-light-primary col-12 m-1 justify-content-center">
                                        <div className="d-flex align-items-center justify-content-between p-2 flex-lg-wrap flex-xl-nowrap">
                                            <div
                                                className="d-flex flex-column "
                                                style={{ zIndex: 1 }}
                                            >
                                                <span className="h5 text-dark text-hover-success">
                                                    Atendimento-
                                                    {
                                                        ContatosDaFila
                                                            .LstFilaEmAtendimento
                                                            .length
                                                    }
                                                </span>
                                                <p className="text-dark-50 m-0 p-0">
                                                    {formatMoneyReais(
                                                        ContatosDaFila.VL_FILAATENDIMENTO
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card card-custom gutter-b bg-light-primary col-12 m-1 justify-content-center">
                                        <div className="d-flex align-items-center justify-content-between p-2 flex-lg-wrap flex-xl-nowrap">
                                            <div
                                                className="d-flex flex-column "
                                                style={{ zIndex: 1 }}
                                            >
                                                <span className="h5 text-dark text-hover-success">
                                                    Contato Efetivo-
                                                    {
                                                        ContatosDaFila
                                                            .LstContatoEfetivo
                                                            .length
                                                    }
                                                </span>
                                                <p className="text-dark-50 m-0 p-0">
                                                    {formatMoneyReais(
                                                        ContatosDaFila.VL_CONTATOEFETIVO
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-wrap flex-row col-12 col-md-2">
                                    <div className="card card-custom gutter-b bg-light-primary m-1 col-12 justify-content-center">
                                        <div className="d-flex align-items-center justify-content-between p-2 flex-lg-wrap flex-xl-nowrap">
                                            <div
                                                className="d-flex flex-column "
                                                style={{ zIndex: 1 }}
                                            >
                                                <span className="h5 text-dark text-hover-success">
                                                    Contato Não Efetivo-
                                                    {
                                                        ContatosDaFila
                                                            .LstContatoNaoEfetivo
                                                            .length
                                                    }
                                                </span>
                                                <p className="text-dark-50 m-0 p-0">
                                                    {formatMoneyReais(
                                                        ContatosDaFila.VL_CONTATONAOEFETIVO
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card card-custom gutter-b bg-light-primary m-1 col-12 justify-content-center">
                                        <div className="d-flex align-items-center justify-content-between p-2 flex-lg-wrap flex-xl-nowrap">
                                            <div
                                                className="d-flex flex-column "
                                                style={{ zIndex: 1 }}
                                            >
                                                <span className="h5 text-dark text-hover-success">
                                                    Tentativa de Contato-
                                                    {
                                                        ContatosDaFila
                                                            .LstTentativaContato
                                                            .length
                                                    }
                                                </span>
                                                <p className="text-dark-50 m-0 p-0">
                                                    {formatMoneyReais(
                                                        ContatosDaFila.VL_TENTATIVACONTATO
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card card-custom wave wave-animate wave-primary col-12 col-md-3 p-2 justify-content-center">
                                    <div className="d-flex align-items-center justify-content-between p-2 flex-lg-wrap flex-xl-nowrap">
                                        <div
                                            className="d-flex flex-column "
                                            style={{ zIndex: 1 }}
                                        >
                                            <span className="h5 text-dark text-hover-success">
                                                Fila Atendimento-
                                                {
                                                    ContatosDaFila
                                                        .LstFilaAtender.length
                                                }
                                            </span>
                                            <p className="text-dark-50 m-0 p-0">
                                                {formatMoneyReais(
                                                    ContatosDaFila?.VL_FILAATENDER
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card card-custom w-auto gutter-b m-5">
                            {!loading ? (
                                <>
                                    <Table
                                        data={lstResultContatosDaFila ?? []}
                                        columns={columns}
                                        keyField={
                                            "ID_CASO_COBRANCA_FILA_ATENDIMENTO"
                                        }
                                        bordered={false}
                                        noSearch
                                        noHover
                                        sizePerPage={2}
                                        controlSizePerPage={controlSizePerPage}
                                        noDataIndication={() => (
                                            <div className="text-black-50 text-center">
                                                Nenhum dado encontrado
                                            </div>
                                        )}
                                        paginationColor="Cobranca"
                                        tableView={{
                                            columns: tableViewColumns,
                                        }}
                                    />
                                </>
                            ) : (
                                <SpinnerComponent />
                            )}
                        </div>
                    </>
                ) : (
                    <div className="text-muted text-center">
                        Erro ao carregar dados
                    </div>
                )
            ) : (
                <SpinnerComponent />
            )}

            {idGrupoCampanha && (
                <ExportExcel
                    baixarExcelController={async () =>
                        ExportarExcelFilaAtendimentosCobrancaController(
                            Number.parseInt(idGrupoCampanha[0]),
                            Number.parseInt(idGrupoCampanha[1])
                        )
                    }
                    nomeArquivo={"Fila_Atendimentos_Cobranca"}
                />
            )}
            <StickyToolbar Filters={Filter} active={filtroAtivo} />
        </>
    );
}
